import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { DataType, RuleInterface } from '@vendasta/automata';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { AutomationReplacementChipsComponent } from '../../../../../common/components';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { SendNotificationFormComponent } from '../../send-notification-common';
import { SmbUsersSelectorService } from '../../../../../data-services/smb-users-selector.service';
import { GenericNotificationID } from '../../send-notification-to-the-user/constants';

@Component({
  selector: 'automata-send-notification-to-smbs',
  templateUrl: './send-notifications-to-smbs-panel.component.html',
  styleUrls: ['./send-notifications-to-smbs-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    AutomationReplacementChipsComponent,
    SendNotificationFormComponent,
  ],
})
export class SendNotificationsToSmbsPanelComponent extends CommonActionPanelComponent implements OnInit {
  supportedDataTypes: DataType[] = [DataType.DATA_TYPE_SMB_USER_ID];
  usersFormControl = new FormControl<string[]>([]);

  @ViewChild('notificationForm', { static: false }) sendNotificationForm: SendNotificationFormComponent;

  constructor(protected readonly smbUsersSelectorService: SmbUsersSelectorService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    const jsonData = this.step?.data ? JSON.parse(this.step.data) : {};
    this.usersFormControl.setValue(jsonData.user_ids || []);
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.sendNotificationForm.form, this.usersFormControl];
  }

  getData(): any {
    const jsonData = this.step?.data ? JSON.parse(this.step.data) : {};
    const notification = this.sendNotificationForm.getData();

    jsonData.user_ids = this.usersFormControl.value;

    jsonData.notification_id = GenericNotificationID;
    jsonData.notification_channel = notification?.notificationChannel;
    jsonData.email_notification = {
      link_template: notification?.emailNotification?.linkTemplate,
      button_text_template: notification?.emailNotification?.buttonTextTemplate,
      subject_template: notification?.emailNotification?.subjectTemplate,
      text_template: notification?.emailNotification?.textTemplate,
    };
    jsonData.in_app_notification = {
      link_template: notification?.inAppNotification?.linkTemplate,
      text_template: notification?.inAppNotification?.textTemplate,
    };

    return jsonData;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  isFormValid(): boolean {
    return this.sendNotificationForm.isFormValid() && this.usersFormControl.valid;
  }

  finishedInitialLoading(): void {
    this.savingEnabled = true;
  }
}
